import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import Chip from "@mui/material/Chip";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListSubheader from "@mui/material/ListSubheader";

import Checkbox from "@mui/material/Checkbox";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";
import DeleteIcon from "@mui/icons-material/Delete";

import toast from "react-hot-toast";

import api from "services/api";
import moment from "moment";
import { capitalCase } from "capital-case";

import colors from "assets/theme/base/colors";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt from "components/UpStyled/Prompt";

import { compare } from "utils/helper";
import { detailAILabUrlPrefix, promptTags, modelMap } from "utils/data";
import { moodboardSortOptions } from "utils/data";

import { Spin, Empty } from "antd";
import SearchIcon from "@mui/icons-material/Search";
import SortIcon from "@mui/icons-material/Sort";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

let allOptions = [];
promptTags.forEach((x) => allOptions.push(...x.children));

const DesignFileList = ({ handleClick = () => {}, handleRefresh = () => {}, currentItemId }) => {
  const [ailabs, setAILabs] = useState([]);
  const [filteredAILabs, setFilteredAILabs] = useState([]);
  const [itemDetail, setItemDetail] = useState();
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const [sortObj, setSortObj] = useState(moodboardSortOptions[0]);
  const [searchStr, setSearchStr] = useState();
  const [sortAnchorEl, setSortAnchorEl] = useState(null);

  useEffect(() => {
    retrieveAILabs();
  }, []);

  const retrieveAILabs = async () => {
    try {
      setLoading(true);
      const { data } = await api.ailab.list({ order: "-updated_at" });
      let myAILab = data?.ailabs || [];

      setAILabs(myAILab);
      setFilteredAILabs(myAILab);
      setLoading(false);
    } catch (err) {
      toast.error(`Retrieve ailabs failed!`);
      setLoading(false);

      console.log(err);
    }
  };

  const loadAILab = async (id) => {
    try {
      setLoading(true);

      const { data } = await api.ailab.get(id);
      setItemDetail(data.data);

      setLoading(false);
    } catch (err) {
      toast.error(`Load ailab failed!`);
      console.log(err);
      setLoading(false);
    }
  };

  const renderResult = () => {
    const resultData =
      itemDetail?.metadata?.resultData && itemDetail.metadata.resultData.length > 0
        ? itemDetail.metadata.resultData[0]
        : null;
    let result = resultData;
    if (!result) {
      return "-";
    }

    const conditional = result?.taskData?.task_meta?.conditional;
    let sketch_img = "";
    let fabric_img = "";
    if (typeof conditional == "string") {
      sketch_img = conditional;
    } else if (typeof conditional == "object") {
      sketch_img = conditional[0];
      fabric_img = conditional[1];
    }

    return (
      <div>
        {result.images && result.images.length > 0 ? (
          <SuiBox display="flex" gap={1} flexWrap="wrap">
            {result.images.map((x, index) => {
              const url = x?.url || x?.imgurl;

              return (
                <SuiBox>
                  <div
                    className="hover-parent"
                    style={{
                      position: "relative",
                      maxWidth: 140,
                      borderRadius: 12,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={x?.url || x?.imgurl}
                      alt={"image_" + index}
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                </SuiBox>
              );
            })}
          </SuiBox>
        ) : (
          <Empty />
        )}
      </div>
    );
  };

  const handleSearchChange = (str) => {
    setSearchStr(str);
    handleSearchFiles(str);
  };

  const handleSearchFiles = (search = searchStr, sort = sortObj) => {
    if (search) {
      const strUpper = search.toUpperCase();
      const searchFields = ["name", "title"];
      const searchResults = ailabs.filter((x) => {
        let result = false;
        for (let i = 0; i < searchFields.length; i++) {
          if (x[searchFields[i]]) {
            if (typeof x[searchFields[i]] == "string") {
              if (x[searchFields[i]].toUpperCase().includes(strUpper)) {
                result = true;
              }
            } else if (typeof x[searchFields[i]] == "object") {
              const text = JSON.stringify(x[searchFields[i]]);
              if (text.toUpperCase().includes(strUpper)) {
                result = true;
              }
            }
          }
        }
        return result;
      });

      let sortedList = searchResults.sort((a, b) => compare(a, b, sort.value));

      setFilteredAILabs(sortedList);
    } else {
      let sortedList = ailabs.sort((a, b) => compare(a, b, sort.value));

      setFilteredAILabs(sortedList);
    }
  };

  const handleCloseSortMenu = () => {
    setSortAnchorEl(null);
  };

  const SortMenu = () => (
    <Menu
      id="basic-menu"
      anchorEl={sortAnchorEl}
      open={Boolean(sortAnchorEl)}
      onClose={handleCloseSortMenu}
    >
      {moodboardSortOptions.map((x) => (
        <MenuItem
          onClick={() => {
            setSortObj(x);
            handleSearchFiles(searchStr, x);
            handleCloseSortMenu();
          }}
        >
          {x.label}
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <div>
      <Spin
        indicator={<CircularProgress color="info" sx={{ mr: 1 }} size={32} />}
        spinning={loading}
      >
        <List
          dense
          sx={{
            width: "100%",
            maxWidth: 360,
            maxHeight: 600,
            overflow: "auto",
            bgcolor: "background.paper",
          }}
          subheader={
            <ListSubheader
              component="div"
              sx={{ display: "flex", gap: 0.5, width: "100%", px: 0.5 }}
            >
              <SuiBox>
                <SuiInput
                  placeholder="Search Keywords"
                  type="text"
                  onChange={(e) => handleSearchChange(e?.target?.value)}
                  size="small"
                  value={searchStr}
                  icon={{
                    direction: "right",
                    component: (
                      <SearchIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleSearchChange(searchStr)}
                      />
                    ),
                  }}
                />
              </SuiBox>

              <IconButton
                aria-label="sort"
                color="dark"
                onClick={(e) => {
                  setSortAnchorEl(e.target);
                }}
              >
                <SortIcon />
              </IconButton>

              <SortMenu />
            </ListSubheader>
          }
        >
          {filteredAILabs.map((item, index) => {
            const labelId = `checkbox-list-secondary-label-${index}`;
            return (
              <ListItem
                key={index}
                secondaryAction={
                  <IconButton
                    aria-label="delete"
                    onClick={() => {
                      setSelectedItem(item);
                      setDeleteVisible(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                }
                disablePadding
              >
                <ListItemButton
                  onClick={() => {
                    setConfirmVisible(true);
                    loadAILab(item.id);
                  }}
                  sx={{
                    backgroundColor: currentItemId == item.id ? colors.light.focus : "transparent",
                  }}
                >
                  <ListItemAvatar
                    sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                  >
                    <SuiBox
                      sx={{
                        borderRadius: ({ borders }) => borders.borderRadius.md,
                        overflow: "hidden",
                        mr: 1,
                      }}
                    >
                      <ImageCardWrapper
                        resizeLimit={0}
                        data={item?.img}
                        height={50}
                        width={50}
                        style={{
                          height: "auto",
                          maxHeight: 50,
                          width: "100%",
                        }}
                        sx={{
                          display: "flex",
                        }}
                        draggable={false}
                      />
                    </SuiBox>
                  </ListItemAvatar>
                  <ListItemText
                    id={labelId}
                    primary={item.name}
                    secondary={moment(item.created_at).format("MM/DD/yyyy")}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
        {deleteVisible && selectedItem?.id ? (
          <Prompt
            heading="Delete design file"
            text={`Are you sure you want to delete: ${selectedItem.name}?`}
            visible={deleteVisible}
            okText="Delete"
            okColor="error"
            handleOk={() => {
              api.ailab
                .delete(selectedItem.id)
                .then(() => {
                  toast.success(`Delete ${selectedItem.name} successfully!`);

                  setFilteredAILabs((prev) => prev.filter((x) => x.id != selectedItem.id));
                  setDeleteVisible(false);
                  const pathnames = window.location.pathname.split("/");
                  let ailab_id = null;
                  if (pathnames.length > 1 && pathnames[pathnames.length - 2] == "fashion-lab") {
                    ailab_id = pathnames[pathnames.length - 1];
                    let newUrl = pathnames.slice(0, pathnames.length - 1).join("/");
                    if (selectedItem.id == ailab_id) {
                      window.history.replaceState("", "Fashion Lab", newUrl);
                      handleRefresh();
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                  toast.error(`Delete ${selectedItem.name} failed!`);
                });
            }}
            handleClose={() => setDeleteVisible(false)}
          />
        ) : null}
        {confirmVisible && itemDetail?.id ? (
          <Prompt
            heading="Switch working file"
            option={{
              fullWidth: true,
              maxWidth: "md",
            }}
            text={
              <SuiBox>
                <SuiTypography sx={{ mb: 1 }} variant="body1">
                  Are you sure you want to switch the current working file below?
                </SuiTypography>
                <SuiBox display="flex" alignItems="flex-start" gap={2}>
                  <SuiBox
                    sx={{
                      borderRadius: ({ borders }) => borders.borderRadius.md,
                      overflow: "hidden",
                      mx: 1,
                      width: 320,
                      minWidth: 320,
                      position: "relative",
                    }}
                  >
                    <ImageCardWrapper
                      resizeLimit={0}
                      data={{
                        type: itemDetail?.metadata?.sketchData?.type,
                        url: itemDetail?.metadata?.sketchData?.imgurl,
                        name: itemDetail?.metadata?.sketchData?.name,
                      }}
                      height={400}
                      width={320}
                      style={{
                        height: "auto",
                        maxHeight: 400,
                        width: "100%",
                      }}
                      sx={{
                        display: "flex",
                      }}
                      draggable={false}
                    />
                    {itemDetail?.metadata?.sketchData?.fabric_imgurl ? (
                      <SuiBox
                        sx={{
                          position: "absolute",
                          right: 0,
                          bottom: 0,
                          border: "1px solid #000000",
                          borderRadius: ({ borders }) => borders.borderRadius.md,
                        }}
                      >
                        <img
                          src={itemDetail?.metadata?.sketchData?.fabric_imgurl}
                          crossOrigin="Anonymous"
                          style={{
                            height: 100,
                            width: 100,
                            borderRadius: 8,
                          }}
                        />
                      </SuiBox>
                    ) : null}
                  </SuiBox>
                  <SuiBox>
                    <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" mb={1}>
                      <SuiBox ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                          Title
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox ml={0.5} mt={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="regular"
                          color="text"
                        >
                          {itemDetail.name}
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>
                    <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" mb={1}>
                      <SuiBox ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                          Prompt
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox ml={0.5} mt={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="regular"
                          color="text"
                        >
                          {itemDetail?.metadata?.jobconf?.prompt || "-"}
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>
                    <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" mb={1}>
                      <SuiBox ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                          Tags
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox ml={0.5} mt={0.5}>
                        <SuiBox
                          display="flex"
                          gap={0.5}
                          alignItems="center"
                          sx={{ flexWrap: "wrap" }}
                        >
                          {itemDetail?.metadata?.jobconf?.prompt_array &&
                          itemDetail?.metadata?.jobconf?.prompt_array.length > 0
                            ? itemDetail?.metadata?.jobconf?.prompt_array.map((pp, index) => {
                                if (pp == "") {
                                  return null;
                                }

                                let foundIndex = allOptions.findIndex((x) => x.value == pp);
                                let label = pp;
                                if (foundIndex > -1) {
                                  label =
                                    allOptions[foundIndex]?.label || allOptions[foundIndex]?.title;
                                }
                                return (
                                  <SuiBox>
                                    <Chip
                                      avatar={
                                        allOptions[foundIndex]?.img ? (
                                          <Avatar
                                            alt="option_avatar"
                                            src={allOptions[foundIndex]?.img}
                                          />
                                        ) : null
                                      }
                                      label={capitalCase(label)}
                                      variant="outlined"
                                    />
                                  </SuiBox>
                                );
                              })
                            : "-"}
                        </SuiBox>
                      </SuiBox>
                      <SuiBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                        mb={1}
                      >
                        <SuiBox ml={0.5} lineHeight={0} display="inline-block">
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Results
                          </SuiTypography>
                        </SuiBox>
                        <SuiBox ml={0.5} mt={0.5}>
                          {renderResult()}
                        </SuiBox>
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                </SuiBox>
              </SuiBox>
            }
            visible={confirmVisible}
            okText="Confirm"
            okColor="info"
            handleOk={() => {
              handleClick(itemDetail);
              setConfirmVisible(false);
              setItemDetail(null);
            }}
            handleClose={() => {
              setConfirmVisible(false);
              setItemDetail(null);
            }}
          />
        ) : null}
      </Spin>
    </div>
  );
};
export default DesignFileList;
